import {useEffect, useState} from 'react'
import {
    useGetProfileQuery,
    useUpdateProfileMutation,
    useUploadImageMutation,
} from 'store/Store.js'
import {i18n} from 'common.js'

const useProfile = () => {
    const {data: user, isProfileLoading, isSuccess} = useGetProfileQuery()
    const [uploadImage] = useUploadImageMutation()
    const [isImageLoading, setImageLoading] = useState(false)
    const [doSave, {isLoading: isSaveProfile}] = useUpdateProfileMutation()
    const [profileImageUrl, setProfileImageUrl] = useState(null)
    const [profileData, setProfileData] = useState({
        firstName: '',
        lastName: '',
        email: '',
    })
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')

    const t18Profile = (text) => i18n.t(`profile.${text}`)

    const handleInputChange = (event) => {
        const {name, value} = event.target
        setProfileData((prevData) => ({
            ...prevData,
            [name]: value,
        }))
    }

    useEffect(() => {
        if (user) {
            setProfileData({
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
            })
        }
    }, [user])
    const handleImageChange = async (e) => {
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append('files', file)

        try {
            setImageLoading(true)
            const {data} = await uploadImage({
                body: formData,
            })
            const {fullLink: imageUrl} = data.files[0]
            setProfileImageUrl(imageUrl)
        } catch (e) {
            console.log('err', e)
        }
        setImageLoading(false)
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        const body = {
            ...profileData,
            profileImageUrl: profileImageUrl || user.profileImageUrl,
        }
        try {
            await doSave(body).unwrap()
            setSnackbarOpen(true)
            setSnackbarMessage(t18Profile('changesSaved'))
        } catch (e) {
            setSnackbarMessage(e?.data?.message ?? 'Something went wrong')
            console.log(e)
        }
    }

    const handleSnackbarClose = (reason) => {
        if (reason === 'clickaway') {
            return
        }
        setSnackbarOpen(false)
    }

    return {
        user,
        userNotFound: !isProfileLoading && !isSuccess,
        profileData,
        profileImageUrl,
        isProfileLoading,
        isImageLoading,
        t18Profile,
        handleSubmit,
        isSaveProfile,
        handleInputChange,
        handleImageChange,
        snackbarOpen,
        handleSnackbarClose,
        snackbarMessage,
    }
}

export default useProfile
